import { useTheme } from '@mui/material';
import { Flex, SlidingPanel } from '@components';
import { useIntl } from 'react-intl';
import { NewCustomerForm } from '../NewCustomerForm/NewCustomerForm';

export interface NewCustomerPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export const NewCustomerPanel = ({
  isOpen,
  onClose,
}: NewCustomerPanelProps) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <SlidingPanel
      anchor='right'
      open={isOpen}
      onClose={onClose}
      title={intl.formatMessage({ id: 'crm.addCustomer' })}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      PaperProps={{
        sx: {
          padding: theme.spacing(14),
          borderRadius: 3,
          width: { xs: '100%', md: '40%' },
        },
      }}
    >
      <Flex flex={1} mt={14}>
        <NewCustomerForm onSave={onClose} />
      </Flex>

      {/* TODO: Uncomment when BE implementation for CSV upload is ready */}
      {/* <Tabs
        variant='scrollable'
        allowScrollButtonsMobile
        tabItem={[
          {
            id: 'addManually',
            label: intl.formatMessage({ id: 'crm.addManually' }),
            component: (
              <Flex flex={1} mt={14}>
                <NewCustomerForm onSave={onClose} />
              </Flex>
            ),
          },
          {
            id: 'uploadCsv',
            label: intl.formatMessage({ id: 'crm.uploadCsv' }),
            component: (
              <Flex mt={14} width='100%'>
                <DocumentUpload
                  title={intl.formatMessage({
                    id: 'documentUpload.selectCsv',
                  })}
                  onUpload={(data) => console.log(data)}
                  allowedTypes={['text/csv']}
                />
              </Flex>
            ),
          },
        ]}
      /> */}
    </SlidingPanel>
  );
};
